import { useTranslation } from 'react-i18next';
import ConfirmDialog from '../../components/ConfirmDialog';

export default function CredBuildConfirmModal({ onClose, onSubmit }) {
  const { t } = useTranslation();

  return (
    <ConfirmDialog
      open
      onClose={onClose}
      title={t('lease.password.credbuildTitle')}
      body={t('lease.password.credbuildDescription')}
      cancelLabel={t('common.cancel')}
      confirmLabel={t('common.disable')}
      onConfirm={onSubmit}
    />
  );
}
